module.exports = {
  messages: {
    INSIGHTS_LO_HERO_SECTION_MARKER: 'Top picks',
    INSIGHTS_LO_HERO_SECTION_SUBTITLE: 'Highlights from the world of work',
    INSIGHTS_LO_HERO_SECTION_TITLE: 'Recommended',
    INSIGHTS_LO_JOBSEEKER_SECTION_SUBTITLE:
      'Articles offering insights and advice for your job search',
    INSIGHTS_LO_JOBSEEKER_SECTION_TITLE: 'Job search',
    INSIGHTS_LO_METADATA_DESCRIPTION:
      'Discover the latest articles about salaries and job searches on XING!',
    INSIGHTS_LO_METADATA_TITLE: 'Your job and career insights',
    INSIGHTS_LO_SALARY_DESCRIPTION:
      'How much do you currently earn based on full-time hours?',
    INSIGHTS_LO_SALARY_SECTION_SUBTITLE: 'Articles all about salaries',
    INSIGHTS_LO_SALARY_SECTION_TITLE: 'Salary',
    INSIGHTS_LO_SALARY_SIGNUP_CTA: 'Register now and compare',
    INSIGHTS_LO_SALARY_SUBTITLE:
      'Compare your salary with XING members in similar roles.',
    INSIGHTS_LO_SALARY_TITLE: 'Earning a fair wage?',
    INSIGHTS_LO_SIGNUP_CARD_CTA: 'Register now',
    INSIGHTS_LO_SIGNUP_CARD_DESCRIPTION:
      'There’s more in store for you! Register now for access to every available article.',
    INSIGHTS_LO_SIGNUP_TEASER_CTA: 'Register now',
    INSIGHTS_LO_SIGNUP_TEASER_DESCRIPTION:
      'Register now for access to articles and advice matching your job preferences.',
    INSIGHTS_LO_SIGNUP_TEASER_TITLE: 'Articles to match your working life',
  },
};
